var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { moveCanceledObjectToLastIndex, processFulfillmentGroup, } from '../../utils/order-details/OrderDetailsUtils';
import { OrderDetailsHeader } from '../order-details/OrderDetailsHeader';
import { OrderDetailsMain } from '../order-details/OrderDetailsMain';
import { OrderPaymentInformation } from '../order-details/OrderPaymentInformation';
import { OrderTotal } from '../order-details/OrderTotal';
import { CancellationDrawer, } from '../shared/cancellation-drawer/CancellationDrawer';
import { EditDeliveryInstructionsDrawer, } from '../order-details/EditDeliveryInstructions/EditDeliveryInstructionsDrawer';
import { useEditDeliveryInstructionsContext } from '../../hooks/useContexts';
import { PTCProvider } from '../../contexts/PTCContext';
export var OnlineOrder = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var customerType = _a.customerType, formData = _a.formData;
    var location = useLocation();
    var _k = useState(false), cancellationDrawerOpen = _k[0], setCancellationDrawerOpen = _k[1];
    var setEditDeliveryInstructionsDrawerOpen = useEditDeliveryInstructionsContext().setEditDeliveryInstructionsDrawerOpen;
    var toggleDrawer = function () {
        setCancellationDrawerOpen(false);
        setEditDeliveryInstructionsDrawerOpen(false);
    };
    var _l = useState({}), cancelInfo = _l[0], setCancelInfo = _l[1];
    var _m = useState([]), cancellationItems = _m[0], setCancellationItems = _m[1];
    if (!formData) {
        return null;
    }
    var encryptedBigReceiptRequestIndex = (formData === null || formData === void 0 ? void 0 : formData.encryptedBigReceiptRequests)
        ? (_b = Object.keys(formData === null || formData === void 0 ? void 0 : formData.encryptedBigReceiptRequests)) === null || _b === void 0 ? void 0 : _b.find(function (key) { return key.charAt(0) === 'H'; })
        : '';
    var displayOrderNumber = function () {
        var _a, _b, _c, _d, _e;
        if (((_a = formData === null || formData === void 0 ? void 0 : formData.orderNumber) === null || _a === void 0 ? void 0 : _a.length) > 1 &&
            (formData === null || formData === void 0 ? void 0 : formData.registerNumber) === 0 &&
            ((_b = formData === null || formData === void 0 ? void 0 : formData.orderNumber) === null || _b === void 0 ? void 0 : _b[0]) === 'H') {
            return (_c = formData === null || formData === void 0 ? void 0 : formData.orderNumbers) === null || _c === void 0 ? void 0 : _c[1];
        }
        return (_d = formData === null || formData === void 0 ? void 0 : formData.orderNumber) !== null && _d !== void 0 ? _d : (_e = formData === null || formData === void 0 ? void 0 : formData.orderNumbers) === null || _e === void 0 ? void 0 : _e[0];
    };
    var destructureFulfillmentGroupForCanceledOrder = (formData === null || formData === void 0 ? void 0 : formData.fulfillmentGroups) &&
        processFulfillmentGroup(formData === null || formData === void 0 ? void 0 : formData.fulfillmentGroups);
    var modifiedFulfillmentGroups = destructureFulfillmentGroupForCanceledOrder &&
        moveCanceledObjectToLastIndex(destructureFulfillmentGroupForCanceledOrder);
    var orderDetailsRequestParams = {
        orderDetailsRoute: location.pathname,
        orderNumber: (_c = formData === null || formData === void 0 ? void 0 : formData.orderNumber) !== null && _c !== void 0 ? _c : (_d = formData === null || formData === void 0 ? void 0 : formData.orderNumbers) === null || _d === void 0 ? void 0 : _d[0],
        salesDate: '',
        storeNumber: formData === null || formData === void 0 ? void 0 : formData.storeNumber,
        transactionId: 0,
        registerNumber: 0,
        orderIndex: 0,
        customerAccountId: '',
    };
    var CancellationDrawerProps = {
        open: cancellationDrawerOpen,
        onClose: toggleDrawer,
        isCancelItemsPage: false,
        cancelAllItems: true,
        orderDetailsData: formData,
        orderDetailsRequestParams: orderDetailsRequestParams,
        cancelInfo: cancelInfo,
        drawerLineItems: cancellationItems,
        isPostRemorse: cancelInfo.isPostRemorseCancel,
        STHorBOSSAlert: cancelInfo.isSTHorBOSSRemorseCancel,
    };
    var EditDeliveryInstructionsDrawerProps = {
        toggleDrawer: toggleDrawer,
    };
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 md:sui-grid-cols-2 lg:gap-6" },
        React.createElement(PTCProvider, null,
            React.createElement(OrderDetailsHeader, { orderDetailsData: formData, encryptedBigReceiptRequest: (_e = formData === null || formData === void 0 ? void 0 : formData.encryptedBigReceiptRequests) === null || _e === void 0 ? void 0 : _e[(_f = Number(encryptedBigReceiptRequestIndex)) !== null && _f !== void 0 ? _f : 0], encryptedReceiptRequest: formData === null || formData === void 0 ? void 0 : formData.encryptedReceiptRequest, orderNumber: displayOrderNumber(), customerType: customerType, filteredFulfillmentObject: modifiedFulfillmentGroups }),
            React.createElement(OrderPaymentInformation, { orderDetailsData: formData, customerType: customerType }),
            React.createElement(OrderDetailsMain, { fulfillmentGroups: modifiedFulfillmentGroups, LineItemsProps: {
                    orderDetailsData: formData,
                }, orderDetailsData: formData, orderDetailsRequestParams: orderDetailsRequestParams, orderNumber: (_g = formData === null || formData === void 0 ? void 0 : formData.orderNumber) !== null && _g !== void 0 ? _g : (_h = formData === null || formData === void 0 ? void 0 : formData.orderNumbers) === null || _h === void 0 ? void 0 : _h[0], setCancelInfo: setCancelInfo, setCancellationDrawerOpen: setCancellationDrawerOpen, setCancellationItems: setCancellationItems, customerType: customerType }),
            React.createElement(OrderTotal, { shippingCharge: formData === null || formData === void 0 ? void 0 : formData.shippingCharge, deliveryCharge: formData === null || formData === void 0 ? void 0 : formData.deliveryCharge, hasPreferredDiscFlag: formData === null || formData === void 0 ? void 0 : formData.preferredDiscFlg, hasProXtraSaving: Boolean(formData === null || formData === void 0 ? void 0 : formData.otherDiscountAmount), orderDetailsData: formData, customerType: customerType, filteredFulfillmentObject: modifiedFulfillmentGroups, militaryDiscount: (_j = formData === null || formData === void 0 ? void 0 : formData.militaryDiscount) !== null && _j !== void 0 ? _j : {} }),
            React.createElement(ErrorBoundary, { name: "cancellation-drawer" },
                React.createElement(CancellationDrawer, __assign({}, CancellationDrawerProps))),
            React.createElement(ErrorBoundary, { name: "edit-delivery-instructions-drawer" },
                React.createElement(EditDeliveryInstructionsDrawer, __assign({}, EditDeliveryInstructionsDrawerProps))))));
};
